import React from "react";
import { Form } from "react-bootstrap";

import classNames from "classnames";

import { useGameSummaryContext } from "../contexts/GameSummary";

import { displayFormAlert } from "../../../../../lib/utils";

const LeagueManagementGameSummary = (): React.JSX.Element => {
    const { methods } = useGameSummaryContext();
    const watchHomeSummary = methods.watch("homeSummary");
    const watchVisitorSummary = methods.watch("visitorSummary");

    return (
        <div data-testid="gameSummary">
            <section className="gameSummary">
                <Form.Group controlId="homeSummary">
                    <Form.Label className={classNames("mt-0 h3")}>
                        Home Game Summary
                    </Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={8}
                        {...methods.register("homeSummary")}
                        maxLength={500}
                    />
                    {watchHomeSummary?.length === 500 &&
                        displayFormAlert({
                            level: "danger",
                            text: "Summary is limited to 500 characters",
                        })}
                </Form.Group>
            </section>
            <section className="gameSummary">
                <Form.Group controlId="visitorSummary">
                    <Form.Label className={classNames("mt-0 h3")}>
                        Visitor Game Summary
                    </Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={8}
                        {...methods.register("visitorSummary")}
                        maxLength={500}
                    />
                    {watchVisitorSummary?.length === 500 &&
                        displayFormAlert({
                            level: "danger",
                            text: "Summary is limited to 500 characters",
                        })}
                </Form.Group>
            </section>
        </div>
    );
};

export default LeagueManagementGameSummary;
